import { format$Price, formatPrice } from "utils/helpers/functions/formatPrice";
import { withLocalCurrency } from "utils/helpers/currency/currencyHelpers";
import vconst from "utils/helpers/structs/vconst";
import TableEmptyRow from "components/others/TableEmptyRow";
import { UserNameItem } from 'modules/user';
import { DateTime as DT } from "luxon";
import ExpendOtherActions from "./ExpendOtherActions";
import { Button } from "react-bootstrap";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import useSettingsParams from "hooks/useSettingsParams";
import { tDirName } from "utils/helpers/i18n/tDirName";
import SolarIcon from 'components/icons/SolarIcon';
  
const ExpendOtherTableBody = ({expends, setShowSpinnerExpend, setShowExpendInfo, onlyView = false}) => {
    
    const { t } = useTranslation(['Objects']);
    const refBtnView = useRef();
    const params = useSettingsParams();
    const asCost = Boolean(params.includeOtherInObjectCost);
    
    return ( 
        <tbody>
            {expends?.map(expend=>{
                const dt = DT.fromMillis(expend.dt||0).toLocaleString(DT.DATE_MED);
                const dtCancel = DT.fromMillis(expend.dtCancel||0).toLocaleString(DT.DATE_MED);
                const rawAmount = Number(expend.expendAmount) || 0;
                const rawAmountRate = Number(expend.expendAmountRate) || 0;
                const displayAmount = asCost ? Math.abs(rawAmount) : rawAmount;
                const displayAmountRate = asCost ? Math.abs(rawAmountRate) : rawAmountRate;
                const amount = format$Price(displayAmount, !asCost);
                const amountRate = formatPrice(displayAmountRate);
                const amountClass = asCost
                    ? ''
                    : (rawAmount > 0 ? 'text-success' : 'text-danger');
                
                return (
                    <tr className={`${expend.expendStatus === vconst.incomeStatCancel ? 'bg-light-danger' :''}`}
                        key={expend.ID}>
                        <td className="user">
                            <UserNameItem
                                user={{
                                    userName       : expend.userName,
                                    userEmail      : expend.userEmail,
                                    userPicture    : expend.userPicture
                                }}/>
                        </td>
                        <td className="team">
                            <h6 className={`mb-1 text-break `}>{tDirName(t, expend.i18nKey, expend.expendName)}</h6>
                            {expend.expendDescription ? (
                            <p className="text-muted f-12 mb-0 my-1 text-truncate" title={expend.expendDescription}>
                                {expend.expendDescription}
                            </p>
                            ) : null}
                            <div className={onlyView ? '' : `d-md-none`}>
                                <p className="text-muted f-12 mb-0 my-1">{dt} </p>
                            </div>
                        </td>
                        {!onlyView &&
                        (<td className="date">
                            <h6 className="mb-1 text-break">{dt}</h6>
                            {expend.expendStatus === vconst.incomeStatCancel && 
                            (<p className={`text-danger fw-medium fs-12 mb-0 my-1 text-truncate`}>{dtCancel}</p>)}
                        </td>)}
                        <td className="amount">
                            {expend.expendStatus === vconst.incomeStatCancel 
                            ?(<h6 className={`mb-1 text-truncate text-muted`}>{amount}</h6>)
                            :(<h6 className={`mb-1 text-truncate ${amountClass}`}>{amount}</h6>)}
                            <p className="text-muted f-12 mb-0 my-1 text-truncate">{withLocalCurrency(amountRate)}</p> 
                        </td>
                        <td className="actions">
                        {onlyView 
                            ? (<>
                            <Button
                                className="p-1 py-0" 
                                ref={refBtnView}
                                size="sm" 
                                variant="light-secondary" 
                                onClick={(e)=>{
                                    e.target?.blur();
                                    e.target?.parentNode?.blur();
                                    refBtnView?.current?.blur();
                                    setShowExpendInfo(expend.ID)
                                }}><SolarIcon name="eye" /></Button>
                            </>)
                            :(<ExpendOtherActions 
                                setShowExpendInfo={setShowExpendInfo}
                                setShowSpinnerExpend={setShowSpinnerExpend}
                                expend={expend}/>)} 
                        </td>
                    </tr>
                )
            })}

            {(!expends || expends?.length === 0) && (
                <TableEmptyRow colSpan={onlyView ? 4 : 5} />
            )}
        </tbody>
    )
}

export default ExpendOtherTableBody;